/*eslint-disable*/
// chakra imports
import { Box, useColorModeValue, Flex, Button, Text } from "@chakra-ui/react";
import React from "react";
import SidebarContent from "./SidebarContent";
import IconBox from "components/Icons/IconBox";
import { ProfileIcon } from "components/Icons/Icons";
import { LogoutIcon } from "components/Icons/Icons";
import { Separator } from "components/Separator/Separator";
import InfoPanel from "./InfoPanel";
import { AddIcon } from "@chakra-ui/icons";
import { Link } from "react-router-dom";

// FUNCTIONS

function Sidebar(props) {
  // to check for active links and opened collapses
  const mainPanel = React.useRef();
  let variantChange = "0.2s linear";

  const { logoText, routes } = props;

  //  BRAND
  //  Chakra Color Mode

  const sidebarBg = useColorModeValue("light.sidebar", "dark.sidebar");
  const sidebarRadius = "0px";
  const sidebarMargins = "0px";

  // SIDEBAR
  return (
    <Box ref={mainPanel}>
      <Box display={{ sm: "none", lg: "block" }} position="fixed">
        {/* <Box
          bg={sidebarBg}
          transition={variantChange}
          w="260px"
          maxW="260px"
          ms={{
            sm: "16px",
          }}
          my={{
            sm: "16px",
          }}
          minH="calc(100vh - 64px)"
          ps="20px"
          pe="20px"
          m={sidebarMargins}
          borderRadius={sidebarRadius}
        >
          <SidebarContent routes={routes}
        logoText={logoText}
        display="none"
        /> */}
        <Box
          className="sidebar-scroll"
          bg={sidebarBg}
          transition={variantChange}
          w="260px"
          maxW="260px"
          h="100vh"
          dir="rtl"
          overflow="hidden"
          display="flex"
          flexDirection="column"
        >
          <InfoPanel />
          <Separator></Separator>
          <Separator></Separator>
          <SidebarContent routes={routes} logoText={logoText} />
<Flex
            w={"full"}
            justifyContent={"center"}
            alignItems={"center"}
            py={0}
            pr={0}
            
          >
            <Button
              as={Link}
              to="/user/sodorhesab/add"
              position="relative"
              zIndex="1"
              overflow="hidden"
              justifyContent="center"
              alignItems="center"
              bg="brand.400"
              w={"full"}
              h={45}
              borderRadius="6px"
              mb={3}
              _hover={{
                bg: "brand.300",
                shadow: "lg",
              }}
              mx={3}
              gap={2}
              sx={{
                "&::before": {
                  content: '""',
                  position: "absolute",
                  top: 0,
                  left: "-75%",
                  width: "50%",
                  height: "100%",
                  background:
                    "linear-gradient(120deg, transparent, rgba(255,255,255,0.5), transparent)",
                  transform: "skewX(-20deg)",
                  animation: "buttonShine 1.2s ease-in-out infinite",
                  zIndex: 2,
                  pointerEvents: "none",
                },
                "@keyframes buttonShine": {
                  "0%": { left: "-75%" },
                  "50%": { left: "125%" },
                  "100%": { left: "125%" },
                },
              }}
            >
              
                <AddIcon color={"white"}/>
                <Text color="white" my="auto" fontSize="sm">
                   صورتحساب جدید
                </Text>
              
            </Button>
          </Flex>
          
        </Box>
      </Box>
    </Box>
  );
}

export default Sidebar;